import Vue from 'vue'
import App from './App.vue'
import i18n from './i18n'
import router from './router'

import VueRx from 'vue-rx';
Vue.use(VueRx);

import Vuelidate from 'vuelidate';
Vue.use(Vuelidate)

Vue.config.productionTip = false

new Vue({
  i18n,
  router,
  render: h => h(App)
}).$mount('#app')


// change other locale
// i18n.locale = 'tw'